import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Capitalizes the first letter of a string
 * @param str - String to capitalize
 * @returns Capitalized string
 */
function capitalize(str) {
    if (!str)
        return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
}
/**
 * Combines class names using clsx and tailwind-merge for optimal Tailwind CSS class handling
 * @param inputs - Class values to combine
 * @returns Merged class string
 */
function cn(...inputs) {
    return twMerge(clsx(inputs));
}
/**
 * Format a date string as a short US date (e.g. "Apr 18, 2026").
 *
 * @param dateString - ISO date string, or null/undefined for no date.
 * @returns Formatted string, or null when input is falsy.
 */
function formatDate(dateString) {
    if (!dateString)
        return null;
    return new Date(dateString).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
}
/**
 * Format a date string as a short US date + time (e.g. "Apr 18, 2026, 3:45 PM").
 *
 * @param dateString - ISO date string, or null/undefined for no date.
 * @returns Formatted string, or null when input is falsy.
 */
function formatDateTime(dateString) {
    if (!dateString)
        return null;
    return new Date(dateString).toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    });
}

export { capitalize, cn, formatDate, formatDateTime };
//# sourceMappingURL=formatters.js.map
